import React, { useEffect, useState } from 'react';
import { basicsettinglist, UpdateOfferData } from '../../../Services/Admin/Admin';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import showCustomAlert from '../../../Extracomponents/CustomAlert/CustomAlert';
import Loader from "../../../../Utils/Loader";

const UpdateOffer = () => {
    const token = localStorage.getItem('token');
    const [clients, setClients] = useState(null);

    const getsettingdetail = async () => {
        try {
            const response = await basicsettinglist(token);
            if (response.status) {
                setClients(response.data);
            }
        } catch (error) {
            console.log('Error fetching settings:', error);
        }
    };

    useEffect(() => {
        getsettingdetail();
    }, []);

    const validationSchema = Yup.object().shape({
        offerstatus: Yup.string().required('Offer Status is required'),
        offeruser_type: Yup.string().required('Offer User Type is required'),
        offerdiscount: Yup.number()
            .required('Offer Discount is required')
            .typeError('Only numbers are allowed')
            .min(0, 'Discount must be at least 0')
            .max(100, 'Discount cannot exceed 100'),
        offertimer: Yup.number()
            .required('Offer Timer is required')
            .typeError('Only numbers are allowed')
            .integer('Only numbers are allowed')
            .min(0, 'Timer must be at least 0'),
        offerpopupcountperday: Yup.number()
            .required('Offer Popup Count is required')
            .typeError('Only numbers are allowed')
            .integer('Only numbers are allowed')
            .min(0, 'Count must be at least 0'),
    });

    if (!clients) {
        return <div><Loader /></div>;
    }

    return (
        <div className='page-content'>
            <div className="page-breadcrumb  d-flex align-items-center mb-3">
                <div className="breadcrumb-title pe-3">Add to Cart Offer</div>
                <div className="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0 p-0">
                            <li className="breadcrumb-item">
                                <Link to="/admin/dashboard">
                                    <i className="bx bx-home-alt" />
                                </Link>
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-lg-8 mx-auto">
                    <div className="card radius-15">
                        <Formik
                            enableReinitialize={true}
                            initialValues={{
                                offerstatus: String(clients[0].offerstatus ?? 0),
                                offeruser_type: clients[0].offeruser_type ?? 0,
                                offerdiscount: clients[0].offerdiscount ?? 0,
                                offertimer: clients[0].offertimer ?? 0,
                                offerpopupcountperday: clients[0].offerpopupcountperday ?? 0,
                            }}
                            validationSchema={validationSchema}
                            onSubmit={async (values, { setSubmitting }) => {
                                const req = {
                                    offerstatus: Number(values.offerstatus),
                                    offeruser_type: Number(values.offeruser_type),
                                    offerdiscount: Number(values.offerdiscount),
                                    offertimer: Number(values.offertimer),
                                    offerpopupcountperday: Number(values.offerpopupcountperday),
                                };

                                try {
                                    const response = await UpdateOfferData(req, token);
                                    if (response.status) {
                                        showCustomAlert("Success", "Offer settings updated successfully");
                                    } else {
                                        showCustomAlert("error", response.message);
                                    }
                                } catch (error) {
                                    showCustomAlert("error", "An unexpected error occurred. Please try again later.");
                                } finally {
                                    setSubmitting(false);
                                }
                            }}
                        >
                            {({ isSubmitting, handleChange, setFieldValue }) => (
                                <Form className="card-body">
                                    <div className='p-4 border radius-15'>
                                        <div className="row">
                                            <div className="row mb-3 align-items-center">
                                                <div className="col-sm-5">
                                                    <label htmlFor="offerstatus" className="col-form-label">
                                                        <b>Offer Status</b>
                                                    </label>
                                                    <Field
                                                        as="select"
                                                        name="offerstatus"
                                                        className="form-control custom-select"
                                                    >
                                                        <option value="1">Active</option>
                                                        <option value="0">Inactive</option>
                                                    </Field>
                                                    <ErrorMessage name="offerstatus" component="div" className="error" />
                                                </div>

                                                <div className="col-sm-5">
                                                    <label htmlFor="offeruser_type" className="col-form-label">
                                                        <b>Offer User Type</b>
                                                    </label>
                                                    <Field
                                                        as="select"
                                                        name="offeruser_type"
                                                        className="form-control custom-select"
                                                    >
                                                        <option value="2">All Users</option>
                                                        <option value="1">Old Users</option>
                                                        <option value="0">New Users</option>
                                                    </Field>
                                                    <ErrorMessage name="offeruser_type" component="div" className="error" />
                                                </div>
                                            </div>

                                            <div className="row mb-3 align-items-center">
                                                <div className="col-sm-5">
                                                    <label htmlFor="offerdiscount" className="col-form-label">
                                                        <b>Offer Discount (%)</b>
                                                    </label>
                                                    <Field
                                                        name="offerdiscount"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Discount"
                                                        onInput={(e) => {
                                                            const value = e.target.value.replace(/[^0-9]/g, '');
                                                            if (value === '' || (parseInt(value) >= 0 && parseInt(value) <= 100)) {
                                                                setFieldValue('offerdiscount', value);
                                                            }
                                                        }}
                                                    />
                                                    <ErrorMessage name="offerdiscount" component="div" className="error" />
                                                </div>

                                                <div className="col-sm-5">
                                                    <label htmlFor="offertimer" className="col-form-label">
                                                        <b>Offer Timer (Seconds)</b>
                                                    </label>
                                                    <Field
                                                        name="offertimer"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Timer in Seconds"
                                                        onInput={(e) => {
                                                            const value = e.target.value.replace(/[^0-9]/g, '');
                                                            setFieldValue('offertimer', value);
                                                        }}
                                                    />
                                                    <ErrorMessage name="offertimer" component="div" className="error" />
                                                </div>
                                            </div>

                                            <div className="row mb-3 align-items-center">
                                                <div className="col-sm-5">
                                                    <label htmlFor="offerpopupcountperday" className="col-form-label">
                                                        <b>Popup Frequency (Per Days)</b>
                                                    </label>
                                                    <Field
                                                        name="offerpopupcountperday"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Days"
                                                        onInput={(e) => {
                                                            const value = e.target.value.replace(/[^0-9]/g, '');
                                                            setFieldValue('offerpopupcountperday', value);
                                                        }}
                                                    />
                                                    <ErrorMessage name="offerpopupcountperday" component="div" className="error" />
                                                </div>
                                            </div>

                                            <div className="col-sm-12 mt-3 text-center">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary px-4"
                                                    disabled={isSubmitting}
                                                >
                                                    {isSubmitting ? 'Submitting...' : 'Submit'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                        <style jsx>{`
                            .error {
                                color: red;
                                font-size: 15px;
                            }
                            .custom-select {
                                appearance: none;
                                background: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="4" height="34" viewBox="0 0 24 24"><path fill="gray" d="M7 10l5 5 5-5z"/></svg>') no-repeat right center;
                                background-size: 1em;
                                padding-right: 1.5em;
                            }                            
                        `}</style>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateOffer;
